import { FC, useCallback } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button,
    Typography,
    Box,
    Container,
    IconButton,
} from '@material-ui/core';
import { Row } from 'components/Row';
import CloseIconModal from 'assets/icons/CloseIconModal';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from 'store/modules/ModalActions';
import '../index.scss'
import useValidationFields from 'pages/Escola/Cadastro/etapas/ProgramasEducacionais/hooks/useValidationFields';
interface ModalProgramaPeriodoProps {
    title: string;
    content: string | React.ReactNode;
    confirmCallback: () => Promise<void>;
    cancelCallback: () => void;
    confirmLabel?: string;
    cancelLabel?: string;
    confirmThemeButton?: string;
    cancelThemeButton?: string;
    modalKey: string;
    validationKey: string;
}

const ModalProgramaPeriodo: FC<ModalProgramaPeriodoProps> = ({
    modalKey,
    validationKey,
    title,
    content,
    confirmCallback,
    cancelCallback,
    confirmLabel,
    cancelLabel,
    confirmThemeButton,
    cancelThemeButton,
}) => {
    const escolas = useSelector((state: any) => state.escolas);
    const languageValues = useSelector((state: any) => state.languages.languageValues);
    const { formIsValid } = useValidationFields(escolas, languageValues, validationKey);
    const dispatch = useDispatch();

    const toClose = useCallback(() => {
        dispatch(closeModal(modalKey));
    }, [dispatch, modalKey]);

    const toCancel = useCallback(() => {
        if (typeof cancelCallback === 'function') {
            cancelCallback();
        }
        toClose();
    }, [cancelCallback, toClose]);

    return (
        <Dialog
            className='GenericModal GenericModal--wide'
            open={true}
            onClose={toCancel}
            closeAfterTransition
            disableEscapeKeyDown
            scroll='body'
            fullScreen
        >
            <Box>
                <DialogTitle className='GenericModal_dialogTitle'>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography className='GenericModal_titleText'>
                            {title}
                        </Typography>
                        <IconButton
                            onClick={(e) => {
                                e.stopPropagation();
                                toCancel();
                            }}
                            size="small"
                        >
                            <CloseIconModal style={{ width: 'auto', height: '22px' }} />
                        </IconButton>
                    </Box>
                </DialogTitle>

                <DialogContent>
                    {content}
                </DialogContent>

                <Container className='GenericModal_dialogActions'>
                    <Row className='GenericModal_row'>
                        <Box
                            className='GenericModal_box-buttons'
                            onClick={(e) => e.stopPropagation()}
                        >
                            <Button
                                className={`GenericModal_action-button ${cancelThemeButton || ''}`}
                                variant='contained'
                                onClick={(e) => {
                                    e.stopPropagation();
                                    cancelCallback?.();
                                    dispatch(closeModal(modalKey));
                                }}
                            >
                                {cancelLabel || 'Cancelar'}
                            </Button>

                            <Button
                                className={`GenericModal_action-button ${confirmThemeButton || ''}`}
                                variant='contained'
                                type='button'
                                onClick={async (e) => {
                                    e.stopPropagation();
                                    if (confirmCallback) {
                                        const result = confirmCallback();
                                        if (result instanceof Promise) {
                                            await result;
                                        }
                                    }
                                    dispatch(closeModal(modalKey));
                                }}
                                disabled={!formIsValid()}
                            >
                                {confirmLabel || 'Confirmar'}
                            </Button>
                        </Box>
                    </Row>
                </Container>
            </Box>
        </Dialog>
    );
};

export default ModalProgramaPeriodo;